"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useColumns = useColumns;
var react_1 = require("react");
var constants_1 = require("../constants");
function useColumns() {
    var columns = (0, react_1.useMemo)(function () { return constants_1.segmentColumns.map(function (column) { return (__assign(__assign({}, column), { id: column.uid })); }); }, []);
    return (0, react_1.useMemo)(function () { return ({ columns: columns, headerColumns: columns }); }, [columns]);
}
